const STORAGE_KEYS = {
  defaultPrice: 'finance.prompt.defaultPrice',
  paymentLink:  'finance.prompt.paymentLink',
};

function todayKey() {
  return new Date().toISOString().split('T')[0]; // YYYY-MM-DD
}

function buildKey(type) {
  return `${STORAGE_KEYS[type]}.${todayKey()}`;
}

export function useFinanceDefaultsPrompt() {
  const shouldAsk = (type) => {
    try {
      return localStorage.getItem(buildKey(type)) !== 'suppressed';
    } catch {
      return true;
    }
  };

  const suppressForToday = (type) => {
    try { localStorage.setItem(buildKey(type), 'suppressed'); } catch { /* ignore */ }
  };

  return { shouldAsk, suppressForToday };
}
